export const mainDishData = [
  {
    name: "Sea Trout",
    price: "$49.91",
    desc: "A small river named Duden flows by their place and supplies",
    id: "dish5",
    imgPath: "assets/images/food/dish-5.jpg.webp"
  },
  {
    name: "Roasted Beef",
    price: "$20.00",
    id: "dish6",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dish-6.jpg.webp"
  },
  {
    name: "Butter Fried Chicken",
    price: "$20.00",
    id: "dish7",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dish-7.jpg.webp"
  },
  {
    name: "Chiken Filet",
    price: "$20.00",
    id: "dish8",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dish-8.jpg.webp"
  },
]
